export default __webpack_public_path__ + "static/media/Manual EMG One.8098bee3.pdf";